import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllQueryParams, useQuery } from "../../helpers/Utils";
import api from "../../services/Api";

export const useGetAllData = (url) => {
    const query = useQuery();
    const location = useLocation();

    const [dataList, setDataList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingList, setLoadingList] = useState(false);
    const [summary, setSummary] = useState(null);

    const getAllData = async (params) => {
        api.getAllData(
            { url, params, setLoading: setLoadingList },
            (response) => {
                setDataList(response.data.content);
                setTotalElements(response.data.totalElements);
                setSummary(response.data.summary);
            }
        );
    };

    useEffect(() => {
        getAllData(getAllQueryParams(query));
    }, [location.search, url]);

    return { dataList, totalElements, loadingList, summary, getAllData };
};
